import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/** 角色 - 新增 Request Schema */
export const createRoleRequestSchema = z.object({
  /** 預設角色 */
  isDefault: z.nativeEnum(TrueFalse),
  /** 角色說明 */
  memo: z.string(),
  /** 角色類型 */
  roleClass: z.string(),
  /** 角色代碼 (主鍵，唯一值不可重覆) */
  roleCode: z.string(),
  /** 後台可使用的模組 */
  roleMenu: z.array(z.string()),
  /** 角色名稱 */
  roleName: z.string(),
  /** 是否可進入後台 */
  toBackend: z.nativeEnum(TrueFalse)
})

/** 角色 - 新增 Request */
export interface CreateRoleRequest
  extends z.infer<typeof createRoleRequestSchema> {}
